import classNames from 'classnames';
import { forwardRef } from 'react';
const modalTitleCss = "m80euke";
export const ModalTitle = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'h2';
  return <Component ref={ref} {...restProps} className={classNames(modalTitleCss, props.className)} />;
});

require("./styles.wyw-in-js.css!=!../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./styles.js");